export var isValidNumber = function isValidNumber(value) {
  return /^\d+$/.test(value);
};
//# sourceMappingURL=field-input-validation.js.map